window.addEventListener('DOMContentLoaded', () => {
  var incl = document.getElementById('set_include_images');
  const dnld_images = document.getElementById('download_images');
  if (dnld_images)
  {
    if (incl) {
      if (incl.checked == true) {
        incl.click(); // toggle visible check
        incl.checked = false; // also set value
      }
    }
  }
  else if (incl)
  {
    incl.parentElement.hidden = true;
  }

  var el = document.getElementById('reject-disposition');
  if (el)
  {
    el.addEventListener('change', (e) => {
      const auditGroupId = e.target.parentElement.dataset.auditGroupId;
      fetch(`/v3/${auditGroupId}/update`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
  
        },
        body: JSON.stringify({ disposition: e.target.value }),
      });
    });
  }
});
